import List from "@/components/list";

const Table = args => {

  const { listeners } = args;
  const audit = listeners["audit"] || function () { };
  const auditDetail = listeners["auditDetail"] || function () { };
  const download = listeners['download'] || function () { };

  const toUpdate = (row) => {
    audit(row);
  }

  const toDetails = (row) => {
    auditDetail(row);
  }

  const Deal = ({ props: { vo } }) => {
    const { row } = vo
    const dealConf = []

    if (row.myAuditStatus == 8) {
      dealConf.push(["icon-audit", "审核", () => toDetails(row), "modifyMobile:audit"])
    } else {
      dealConf.push(["icon-steps", "审核详情", () => toDetails(row), "modifyMobile:audit:info"])
    }



    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Resource = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span
        class="blue_text"
        onClick={() => {
          download(item);
        }}
      >
        {item.verifyName}
      </span>
    );
  };

  const AccountColum = ({ props: { vo, type } }) => {
    const item = vo.row;
    let userName = item.moveUserName
    let userPhone = item.moveUserMobile
    if (type == 2) {
      userName = item.createUserName
      userPhone = item.createUserMobile
    }
    return (
      <div class="user_status">
        <div>
          <div>{userName}</div>
          <div class="audit_char">{userPhone}</div>
        </div>
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "200",
      // render: vo => <AccountColum vo={vo} type={1} />,
    },
    {
      label: "旧手机号",
      prop: "oldMobile",
      minWidth: "200",

    },
    {
      label: "新手机号",
      prop: "newMobile",
      minWidth: "200"
    },
    {
      label: "我的审核状态",
      prop: "myAuditStatusStr",
      minWidth: "100",
      // render: vo => <AccountColum vo={vo} type={2}/>,
    },
    {
      label: "最终审核状态",
      prop: "finalAuditStatusStr",
      minWidth: "100"
    },
    {
      label: "提交时间",
      prop: "submitTime",
      minWidth: "200"
    },

    {
      label: "操作",
      minWidth: "80",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
